define('pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * @class DashboardSuggestedBookingItemView
     */
    return LayoutView.extend({

        template: '#dashboard_suggested_booking_item',

    });

});
